const fileInputs = [...document.querySelectorAll('input[type="file"]')];
const actions = [...document.querySelectorAll('.action')];

fileInputs.forEach((fileInput) => {
    fileInput.addEventListener('change', event => {
        const formGroup = fileInput.closest('.form-group');
        const output = formGroup.querySelector('.selected-file');
        const files = event.target.files;
        const file = files[0];

        console.log('filename: ' + file.name );
        console.log('file size: ' + file.size + ' bytes');
        console.log('file type: ' + file.type);

        output.innerHTML = '';

        if ( file.size < 5000000 ) {
            fileInput.setAttribute('data-filesize', file.size);
            formGroup.classList.remove('is-invalid');
            output.innerHTML = file.name;
        } else {
            fileInput.setAttribute('data-filesize', '');
            formGroup.classList.add('is-invalid');
            output.innerHTML = 'File is too big';
        }
    });
});
